import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createBlock(_component_v_main, { class: "tbdc-fullwidthpage" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h2", null, "We are sorry, the page you requested cannot be found.", -1),
          _createElementVNode("p", { class: "text-grey" }, "The URL may be misspelled or the page you're looking for is no longer available.", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}